import script from "./AdminIPBlacklist.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminIPBlacklist.vue?vue&type=script&setup=true&lang=js"

import "./AdminIPBlacklist.vue?vue&type=style&index=0&id=8932e10c&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8932e10c"]])

export default __exports__